/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".bg-light-gray[_ngcontent-%COMP%]{background-color:#ededed;border-radius:6px}.passwordCriteria[_ngcontent-%COMP%]{background-color:#90ee90}.add-double-checkboxes[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{margin-top:0;width:102px}strong.terms[_ngcontent-%COMP%]{font-size:14px}\n/*# sourceMappingURL=create-password.component.css.map*/"];
export { styles as styles };
